import { KdfType } from '../core-js/src/enums/kdfType'

const ACCESS_TYPE_VALUE = {
  READ: 'access_key_read',
  WRITE: 'access_key_write'
}

const WS_MEMBER_ROLE = {
  ADMIN: 'admin',
  MEMBER: 'member'
}
const WS_MEMBER_STATUS = {
  CREATED: 'created',
  ACCESSED: 'accessed'
}
const PROJECT_MEMBER_ROLE = {
  READ_ONLY: 'project_read_only',
  REGULAR: 'project_regular',
  ADMIN: 'project_admin'
}
const PROJECT_MEMBER_STATUS = {
  CONFIRMED: 'confirmed',
  INVITED: 'invited',
  ACCEPTED: 'accepted'
}
const FILE_TYPE = {
  JSON: 'json',
}

const LANGUAGE = {
  VI: 'vi',
  EN: 'en',
  ZH: 'zh',
  RU: 'ru',
  FR: 'fr'
}

export default {
  SERVICE_SCOPE: 'portal_internal',
  PAGE_SIZE: 50,
  EXPORT_PAGE_SIZE: 1000,
  IMPORT_PAGE_SIZE: 500,
  ACCESS_TYPE_VALUE,
  WS_MEMBER_ROLE,
  WS_MEMBER_STATUS,
  PROJECT_MEMBER_ROLE,
  PROJECT_MEMBER_STATUS,
  FILE_TYPE,
  LANGUAGE,
  CORE_JS_INFO: {
    KDF: KdfType.PBKDF2_SHA256,
    KDF_ITERATIONS: 600000
  },
  LANGUAGES: [
    {
      value: LANGUAGE.EN,
      label: 'common.english',
    },
    {
      value: LANGUAGE.VI,
      label: 'common.vietnamese',
    },
    {
      value: LANGUAGE.ZH,
      label: 'common.chinese',
    },
    {
      value: LANGUAGE.RU,
      label: 'common.russian',
    },
    {
      value: LANGUAGE.FR,
      label: 'common.french',
    }
  ],
  ACCESS_TYPES: [
    {
      value: ACCESS_TYPE_VALUE.READ,
      color: 'default',
      label: 'common.english',
    },
    {
      value: ACCESS_TYPE_VALUE.WRITE,
      color: 'success',
      label: 'common.write',
    },
  ],
  ACCESS_KEY_PERMISSIONS: [
    {
      value: false,
      color: 'default',
      label: 'common.read',
    },
    {
      value: true,
      color: 'success',
      label: 'common.write',
    },
  ],
  ACCESS_KEY_STATUSES: [
    {
      value: false,
      color: 'default',
      label: 'common.inactive',
    },
    {
      value: true,
      color: 'success',
      label: 'common.active',
    },
  ],
  WORKSPACE_MEMBER_ROLES: [
    {
      value: WS_MEMBER_ROLE.MEMBER,
      color: 'blue',
      label: 'roles.member',
    },
    {
      value: WS_MEMBER_ROLE.ADMIN,
      color: 'success',
      label: 'roles.admin',
    },
  ],
  WORKSPACE_MEMBER_STATUSES: [
    {
      value: WS_MEMBER_STATUS.CREATED,
      color: 'blue',
      label: 'statuses.created',
    },
    {
      value: WS_MEMBER_STATUS.ACCESSED,
      color: 'success',
      label: 'statuses.accessed',
    },
  ],
  PROJECT_MEMBER_ROLES: [
    {
      value: PROJECT_MEMBER_ROLE.READ_ONLY,
      color: 'info',
      label: 'roles.project_read_only',
    },
    {
      value: PROJECT_MEMBER_ROLE.REGULAR,
      color: 'blue',
      label: 'roles.project_regular',
    },
    {
      value: PROJECT_MEMBER_ROLE.ADMIN,
      color: 'success',
      label: 'roles.project_admin',
    },
  ],
  PROJECT_MEMBER_STATUSES: [
    {
      value: PROJECT_MEMBER_STATUS.CONFIRMED,
      color: 'info',
      label: 'statuses.confirmed',
    },
    {
      value: PROJECT_MEMBER_STATUS.INVITED,
      color: 'blue',
      label: 'statuses.invited',
    },
    {
      value: PROJECT_MEMBER_STATUS.ACCEPTED,
      color: 'success',
      label: 'statuses.accepted',
    }
  ],
  IMPORT_EXPORT_FILE_TYPES: [
    {
      value: FILE_TYPE.JSON,
      label: 'Json'
    }
  ],
  SMTP_PROVIDERS: [
    {
      name: 'Other SMTP provider',
      host: '',
      port: ''
    },
    {
      name: 'Gmail',
      host: 'smtp.gmail.com',
      port: '587'
    },
    {
      name: 'Microsoft Outlook',
      host: 'smtp.office365.com',
      port: '587'
    },
    {
      name: 'Yahoo',
      host: 'smtp.mail.yahoo.com',
      port: '587'
    },
    {
      name: 'Mailtrap Email Sending',
      host: 'live.smtp.mailtrap.io',
      port: '587'
    },
    {
      name: 'Mailgun',
      host: 'mtp.mailgun.org',
      port: '587'
    },
    {
      name: 'Apple mail',
      host: 'smtp.mail.me.com',
      port: '587'
    },
    {
      name: 'Mandrill',
      host: 'smtp.mandrillapp.com',
      port: '587'
    },
    {
      name: 'SparkPost',
      host: 'mtp.sparkpostmail.com',
      port: '587'
    },
    {
      name: 'Postmark',
      host: 'smtp.postmarkapp.com',
      port: '587'
    },
  ],
  ENV_COLORS: [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ffffff",
    "#fafafa",
    "#f5f5f5",
  ],
  SORT_OPTIONS: [
    {
      key: 'name_ascending',
      orderField: 'name',
      orderDirection: 'asc',
      label: 'sort_options.name_ascending',
    },
    {
      key: 'name_descending',
      orderField: 'name',
      orderDirection: 'desc',
      label: 'sort_options.name_descending',
    },
    {
      key: 'time_ascending',
      orderField: 'updatedDate',
      orderDirection: 'asc',
      label: 'sort_options.time_ascending',
    },
    {
      key: 'time_descending',
      orderField: 'updatedDate',
      orderDirection: 'desc',
      label: 'sort_options.time_descending',
    }

  ]
}
